import React from "react";

const GOVERNANCE_CONFIG = {
    approved:     { label: "Approved",     color: "#16a34a", bg: "rgba(22,163,74,0.15)" },
    pilot:        { label: "Pilot",        color: "#2563eb", bg: "rgba(37,99,235,0.15)" },
    experimental: { label: "Experimental", color: "#7c3aed", bg: "rgba(124,58,237,0.15)" },
    preview_only: { label: "Preview Only", color: "#9feae8", bg: "rgba(159,234,232,0.1)" },
    degraded:     { label: "Degraded",     color: "#dc2626", bg: "rgba(220,38,38,0.15)" },
    disabled:     { label: "Disabled",     color: "#6b7280", bg: "rgba(107,114,128,0.15)" },
};

export function governanceColor(state) {
    return (GOVERNANCE_CONFIG[state] || GOVERNANCE_CONFIG.experimental).color;
}

export default function GovernanceBadge({ state, size = "sm" }) {
    const cfg = GOVERNANCE_CONFIG[state] || { label: state || "Unknown", color: "#6b7280", bg: "rgba(107,114,128,0.15)" };
    return (
        <span
            className="rd-governance-badge"
            style={{
                "--rd-badge-color": cfg.color,
                "--rd-badge-font-size": size === "lg" ? "12px" : "10px",
                "--rd-badge-height": size === "lg" ? "27px" : "23px",
                "--rd-badge-padding": size === "lg" ? "3px 10px" : "3px 8px",
            }}
        >
            {cfg.label}
        </span>
    );
}
